export const IconeTwitch = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.61994 4L4.93994 8.81V25H10.7799V28H14.4099L17.3399 25H21.6599L28.0699 18.53V4H6.61994ZM25.8099 18.01L22.2699 21.48H16.3499L13.6099 24.32V21.48H8.45994V6.08H25.8099V18.01Z"
        fill="#F5F5F5"
      />
      <path d="M22.24 10.49H20.29V16.9H22.24V10.49Z" fill="#F5F5F5" />
      <path d="M16.5 10.49H14.55V16.9H16.5V10.49Z" fill="#F5F5F5" />
    </svg>
  );
};
